import { Axios } from "@/utils/axios";
import { SangjoFuneralDirectorProps } from "@/types/sangjoType";

interface Question {
  id: number;
  author: string;
  content: string;
  created_at: string;
  is_users: boolean;
  is_scrapped: boolean;
  status: "답변 대기 중" | "답변 완료";
  answer: {
    author: SangjoFuneralDirectorProps | null;
    content: string;
    created_at: string;
  };
}
export const getQuestion = async (id: number) => {
  const { data } = await Axios.get<Question>(`/questions/${id}/`);
  return data;
};
